// =====================================================
// WeLearn Pro Player - Progression module
// =====================================================

import Debug from './util/debugHelper';
//import Swal from 'sweetalert2';
//import { formatResultsErrors } from 'jest-message-util';

export default class Progress {
    constructor(player) {
        this.player = player;
        this.debug = new Debug(this.player.options.debug);
    }

    /**
     * Build video progress data
     * @returns {*} - Video progress data
     */
    buildProgressData() {
        // Clear old timestamp data
        this.player.progressData.timestamp = [];

        // Save 'this' reference to use within jQuery scope.
        let self = this;

        // Iterate through data-timestamp span
        $('span.tick.watched[data-timestamp]').each(function () {
            self.player.progressData['timestamp'].push(($(this).attr('data-timestamp')));
        });

        self.player.progressData.progress = self.player.progressPercentage;

        // Debug console log
        if (this.player.options.debug === true) {
            if (Math.floor(self.player.plyrPlayer.currentTime) !== 0) {
                this.debug.log('***** Built watch progress data *****');
                this.debug.log(self.player.progressData);
                this.debug.log('*************************************');
            }
        }

        return this.player.progressData;
    }

    /**
     * Update video progress periodically
     * @param data - Progress data
     */
    updateVideoData(progressData) {
        let self = this;
        const urlParams = new URLSearchParams(window.location.search);

        try {
            let cid = self.player.progressData.courseId;
            let csm = urlParams.get('csm');
            let cb = self.player.progressData.courseBatchId;
            let jqXhr = $.ajax({
                url: self.player.options.progress.update.url,
                data: {
                    courseId: cid,
                    courseSectionModuleId: csm,
                    cb: cb,
                    progressData: JSON.stringify(progressData)
                },
                async: true,
                type: 'post',
            });

            jqXhr.always(function () {
                let statusCode = jqXhr.status;
                let specialResponse = JSON.parse(jqXhr.getResponseHeader('X-Responded-JSON'));
                let isSentWithoutIssue = (specialResponse === null) && (statusCode === 200);
                let isAlertEnabled = self.player.options.progress.update.alert === true;

                if (isSentWithoutIssue) {
                    $('div.wlpVideo__progress-bar > .tick.watched').addClass('saved');
                    if (self.player.options.debug === true) {
                        console.log('DEBUG: Student progress successfully saved.');
                    }
                } else {
                    $('div.wlpVideo__progress-bar > .tick.watched').addClass('error');

                    if (isAlertEnabled) {
                        if (specialResponse.status === 401) {
                            // self.player.invokeAlert($.i18n('ErrorPleaseLogin'));
                            Swal.fire({
                                type: 'error',
                                title: 'Error!',
                                text: $.i18n('ErrorPleaseLogin'),
                            }).then((result) => {
                                if (result.value) {
                                    window.location.href = '/Account/Login?ReturnUrl=' + encodeURIComponent('/Home/CourseDetail/' + cid + '?cb=' + cb);
                                }
                            })
                            return;
                        }

                        //self.player.invokeAlert(self.player.options.progress.update.alertMessage);
                        self.player.invokeAlert($.i18n('ErrorUpdateProgress'))
                        return;
                    }
                }
            });
        } catch (e) {
            $('div.wlpVideo__progress-bar > .tick.watched').addClass('error');
            this.debug.log('DEBUG: Student progress cannot be saved :: ' + e);
        }

    }
}
